import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { programs } from "@/mocks/programs";
import { useTranslatedList } from "@/hooks/useTranslatedList";

export default function ReligionPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Religion & Community | L+TV TÉLÉVISION";
  }, []);

  const religionPrograms = useTranslatedList(
    programs.filter((p) => p.department === "Religion & Community" || p.category === "Religion"),
    ["name", "description", "category"],
  );

  return (
    <div className="pt-20">
      <div className="bg-primary-900 py-8">
        <div className="ltv-container">
          <h1 className="text-2xl md:text-3xl font-bold text-white">{t("religion.title")}</h1>
          <p className="text-white/60 text-sm mt-1">{t("religion.subtitle")}</p>
        </div>
      </div>

      <div className="ltv-container py-8 md:py-12">
        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-foreground-700 leading-relaxed text-lg text-center">
            {t("religion.intro")}
          </p>
        </div>

        <h2 className="ltv-section-title">{t("religion.programs")}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {religionPrograms.map((p) => (
            <Link key={p.id} to={`/programs/${p.slug}`} className="ltv-card group">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute top-3 left-3 bg-accent-500 text-white text-xs font-semibold px-2 py-1 rounded">{p.category}</div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">{p.name}</h3>
                <p className="text-sm text-foreground-600 mt-1 line-clamp-2">{p.description}</p>
                <div className="flex items-center gap-2 mt-3 text-xs text-foreground-500">
                  <i className="ri-user-line"></i>
                  <span>{p.presenter}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}